import m from "../../geodata/es2015/capeVerdeHigh";
window.am4geodata_capeVerdeHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/capeVerdeHigh.js
// module id = null
// module chunks = 